import { render, staticRenderFns } from "./TaskTableView.vue?vue&type=template&id=0b8906f2&scoped=true&"
import script from "./TaskTableView.vue?vue&type=script&lang=js&"
export * from "./TaskTableView.vue?vue&type=script&lang=js&"
import style0 from "./TaskTableView.vue?vue&type=style&index=0&id=0b8906f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8906f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8906f2')) {
      api.createRecord('0b8906f2', component.options)
    } else {
      api.reload('0b8906f2', component.options)
    }
    module.hot.accept("./TaskTableView.vue?vue&type=template&id=0b8906f2&scoped=true&", function () {
      api.rerender('0b8906f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableView/TaskTableView.vue"
export default component.exports